import React from "react";
import {
  Box,
  Grid,
  Select,
  MenuItem,
  Container,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import {
  Task,
  Place,
  Apartment,
  LocalPhone,
  MailOutline,
  LocalParking,
  DriveFileRenameOutline,
  KeyboardArrowDownOutlined,
  AddPhotoAlternateOutlined,
} from "@mui/icons-material";
import HeadingText from "./HeadingText";

function Complex({ register, errors, watch, setValue }) {
  const fileName = watch("fileName");

  return (
    <Container maxWidth="md">
      <Grid container>
        <Grid item xs={12} sm={5}>
          <HeadingText
            main="Complex Information"
            sub="Input all the required information to continue."
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <DriveFileRenameOutline
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Complex Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="text"
              placeholder="Enter Complex Name"
              style={{ marginTop: 20 }}
              {...register("comName", { required: "Complex Name is required" })}
            />
            {errors.comName && (
              <p className="error">{errors.comName.message}</p>
            )}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <Place
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Complex Address <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="text"
              placeholder="Enter Complex Address"
              style={{ marginTop: 20 }}
              {...register("comAddress", {
                required: "Complex Address is required",
              })}
            />
            {errors.comAddress && (
              <p className="error">{errors.comAddress.message}</p>
            )}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <Apartment
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Number of Units <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="number"
              placeholder="Enter Number of Units"
              style={{ marginTop: 20 }}
              {...register("comUnit", {
                required: "Number of Units is required",
                min: { value: 1, message: "Must be at least 1" },
              })}
            />
            {errors.comUnit && (
              <p className="error">{errors.comUnit.message}</p>
            )}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <MailOutline
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Complex Email <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="email"
              placeholder="Enter Complex Email"
              style={{ marginTop: 20 }}
              {...register("comMail", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                  message: "Invalid email format",
                },
              })}
            />
            {errors.comMail && (
              <p className="error">{errors.comMail.message}</p>
            )}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <LocalPhone
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Complex Phone Number
            </label>
            <input
              className="text_input"
              type="tel"
              placeholder="Enter Complex Phone Number"
              style={{ marginTop: 20 }}
              {...register("comPhone", {
                required: "Phone Number is required",
              })}
            />
            {errors.comPhone && (
              <p className="error">{errors.comPhone.message}</p>
            )}
          </Box>

          <Box sx={{ marginBottom: "24px" }}>
            <FormControl fullWidth size="small" focused>
              <InputLabel>
                Gated or Open Complex
              </InputLabel>
              <Select
                label="Gated or Open Complex"
                {...register("gate", { required: "Please select an option" })}
                value={watch("gate") || ""}
                onChange={(e) => setValue("gate", e.target.value)}
                color="primary"
                IconComponent={KeyboardArrowDownOutlined}
                sx={{
                  color: "#186FE7",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                }}
                startAdornment={
                  <LocalParking
                    sx={{
                      backgroundColor: "#186fe7",
                      color: "#fff",
                      borderRadius: "3px",
                      scale: "0.8",
                    }}
                  />
                }
              >
                <MenuItem disabled value="">
                  Select Gated or Open Complex
                </MenuItem>
                <MenuItem value="Gated Complex">Gated Complex</MenuItem>
                <MenuItem value="Open Complex">Open Complex</MenuItem>
              </Select>
            </FormControl>
            {errors.gate && <p className="error">{errors.gate.message}</p>}
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={5}>
          <HeadingText
            main="Upload Images of Complex"
            sub="Upload relevant images for guest and tenants to identify the property."
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <Box
              component="label"
              sx={{
                backgroundColor: "#fff",
                textAlign: "center",
                display: "block",
                position: "relative",
                border: fileName ? "1px solid #186FE7" : "1px dashed #186FE7",
                borderRadius: "8px",
                width: "100%",
                padding: fileName ? "8px 8px 8px 48px" : "20px",
                "&:hover": { backgroundColor: "#f9f9f9" },
              }}
            >
              <label style={{ position: "absolute", left: 10, top: -20, color: "#186FE7", fontSize: 14 }}>
                Complex Image
              </label>
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={(e) =>
                  setValue("fileName", e.target.files[0]?.name || "")
                }
              />
              {fileName ? (
                <Box>
                  <Task
                    sx={{
                      color: "#186FE7",
                      position: "absolute",
                      top: "25px",
                      left: "12px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "Arimo",
                      color: "#186FE7",
                      textAlign: "left",
                    }}
                  >
                    {fileName}
                  </Typography>
                </Box>
              ) : (
                <>
                  <AddPhotoAlternateOutlined color="primary" fontSize="large" />
                  <Typography sx={{ fontFamily: "Arimo", color: "#186FE7" }}>
                    Drop or click to upload your image here
                    <span sx={{ fontSize: "10px" }}>Supports JPEG, PNG</span>
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Complex;
